<p-toast></p-toast>
<div class="grid p-fluid" *ngIf="!loadingLeaseDetails">
    <div class="col-12 card" *ngIf="leaseDetails">
        <h1>View Lease</h1>
    </div>
    <div class="col-12 sm:col-12 md:col-9 h-full" *ngIf="leaseDetails">
        <iframe *ngIf="leaseDetails?.blobURLSafe" [src]="leaseDetails.blobURLSafe" width="100%" style="height: 100vh"></iframe>
    </div>
    <div class="col-12 sm:col-12 md:col-3 card" *ngIf="leaseDetails">
        <h1>Details</h1>
        <div class="col-12">
            <h3>Name :</h3>
            <p class="mb-0">{{ leaseDetails.file_name }}</p>
        </div>
        <div class="col-12">
            <h3>File Size :</h3>
            <p class="mb-0">{{ leaseDetails.file_size }}</p>
        </div>
        <div class="col-12">
            <h3>File Type :</h3>
            <p class="mb-0">PDF</p>
        </div>
        <div class="col-12">
            <h3>Location :</h3>
            <p class="mb-0">{{ leaseDetails.location_id }}</p>
        </div>
        <div class="col-12">
            <h3>Suite :</h3>
            <p class="mb-0">{{ leaseDetails.suite }}</p>
        </div>
        <div class="col-12">
            <h3>Account :</h3>
            <p class="mb-0">{{ leaseDetails.account }}</p>
        </div>
        <div class="col-12">
            <a pButton pRipple icon="pi pi-download" class="p-button-rounded p-button-success no-underline w-auto" label="Download" (click)="downloadFile()"></a>
        </div>
    </div>
</div>
<p-progressSpinner class="spinner" *ngIf="loadingLeaseDetails"></p-progressSpinner>